function getTimeUnit (timestamp, options = {}) {
  const {
    round = true, // 是否四舍五入
    precision = 1, // 小数精度
    shortUnit = false, // 是否使用短单位（如h, d, y）
    includeZero = false // 是否在值为0时返回单位
  } = options
  // 定义时间单位和对应的毫秒数
  const units = [
    { value: 1000, name: '秒', short: 's' },
    { value: 60 * 1000, name: '分钟', short: 'm' },
    { value: 60 * 60 * 1000, name: '小时', short: 'h' },
    { value: 24 * 60 * 60 * 1000, name: '天', short: 'd' },
    { value: 7 * 24 * 60 * 60 * 1000, name: '周', short: 'w' },
    { value: 30 * 24 * 60 * 60 * 1000, name: '月', short: 'M' }, // 近似值
    { value: 365 * 24 * 60 * 60 * 1000, name: '年', short: 'y' } // 近似值
  ]
  // 处理零值情况
  if (timestamp === 0) {
    return includeZero
      ? { value: 0, unit: shortUnit ? units[0].short : units[0].name }
      : { value: 0, unit: '' }
  }
  // 处理负值
  const isNegative = timestamp < 0
  const absTimestamp = Math.abs(timestamp)
  // 找到最合适的单位
  let result = { value: absTimestamp, unit: shortUnit ? 'ms' : '毫秒' }
  for (let i = 0; i < units.length; i++) {
    const unit = units[i]
    if (absTimestamp >= unit.value) {
      let value = absTimestamp / unit.value
      // 应用精度和舍入
      if (round) {
        result.value = Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision)
      } else {
        result.value = parseFloat(value.toFixed(precision))
      }
      result.unit = shortUnit ? unit.short : unit.name
    } else {
      break
    }
  }
  // 恢复负值
  if (isNegative) {
    result.value = -result.value
  }
  return result
}

/**
 * 将时间戳转换为格式化的字符串
 * @param {number} timestamp - 时间戳（毫秒）
 * @param {object} options - 可选配置
 * @returns {string} - 格式化后的时间字符串
 */
export default function getTimeDistance (timestamp, options = {}) {
  const {
    format = '{value} {unit}', // 输出格式
    ...restOptions
  } = options
  const { value, unit } = getTimeUnit(timestamp, restOptions)
  return format
    .replace('{value}', value)
    .replace('{unit}', unit)
}



// WEBPACK FOOTER //
// ./src/utils/getTimeDistance.js